// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer theme,base,primereact;@layer components{.navLogoDown{opacity:.5;animation:2.5s ease-in-out infinite esNavLogoPulse}@media (prefers-reduced-motion:reduce){.navLogoDown{animation:none}}}@layer utilities;@keyframes esNavLogoPulse{0%,to{opacity:.5}50%{opacity:.25}}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
